module.exports = __webpack_public_path__ + "img/banner.c1467be.png";